import React from "react";
import styled from "styled-components";
import { Chart } from "../components/Charts/Charts";

import { useMetricData } from "../hooks/UseMetricData";
import { useSubscription } from "../../context/SubscriptionCheckoutContext";
import { SubscriptionCoverBanner } from "../components/SubscriptionCovers";

export default function LineChartWidget() {
  const { valuationChartData, propDfr } = useMetricData();
  const { openCheckout } = useSubscription();
  const openSubscriptionCheckout = () => {
    openCheckout();
  };

  // Map the data to include all lines
  const mappedData = valuationChartData?.years?.map((year, index) => {
    const dataPoint = { year, unit: "kr/m³sk" };

    // Add each line's data with a unique key
    valuationChartData.line?.forEach((lineData, lineIndex) => {
      dataPoint[`line${lineIndex}`] = lineData.data[index];
    });

    return dataPoint;
  });

  return (
    <div className="flex flex-col space-y-3 p-4 relative">
      {!propDfr ? (
        <SubscriptionCoverBanner
          onClick={openSubscriptionCheckout}
          label="Fastighetsvärde"
        />
      ) : null}
      <div style={!propDfr ? { filter: "blur(9px)" } : {}}>
        <Chart
          name="LinesChart"
          data={mappedData}
          dataKey={{
            xAxis: "year",
          }}
          dataset={valuationChartData?.line?.map((itm, idx) => ({
            color: "#7C6ED9",
            dataKey: `line${idx}`,
          }))}
          size={{
            width: "100%",
            height: 342.1053,
          }}
          domain={{
            yAxis: [
              (dataMin) => Math.floor(dataMin / 100) * 100,
              (dataMax) => Math.ceil(dataMax / 100) * 100 + 50,
            ],
          }}
        ></Chart>
      </div>
    </div>
  );
}
